import React from 'react';
interface ReceiptDetailsProps {
  customerName: string;
  paymentMethod: string;
  paymentTime: string;
  remarks: string;
}
export function ReceiptDetails({
  customerName,
  paymentMethod,
  paymentTime,
  remarks
}: ReceiptDetailsProps) {
  return <div className="mb-8" data-id="element-1000">
      <div className="grid grid-cols-[180px_1fr] gap-x-8 gap-y-2.5 text-sm" data-id="element-1001">
        <div className="text-xs font-semibold text-neutral-700" data-id="element-1002">
          Received From:
        </div>
        <div className="text-sm font-medium text-neutral-900" data-id="element-1003">
          {customerName}
        </div>

        <div className="text-xs font-semibold text-neutral-700" data-id="element-1004">
          Payment Method:
        </div>
        <div className="text-sm text-neutral-900" data-id="element-1005">{paymentMethod}</div>

        <div className="text-xs font-semibold text-neutral-700" data-id="element-1006">
          Payment Time:
        </div>
        <div className="text-sm text-neutral-900" data-id="element-1007">{paymentTime}</div>

        <div className="text-xs font-semibold text-neutral-700" data-id="element-1008">Remarks:</div>
        <div className="text-sm text-neutral-900 whitespace-pre-line" data-id="element-1009">
          {remarks}
        </div>
      </div>
    </div>;
}